export default __webpack_public_path__ + "static/media/1_SE_IPPF_logo_1.2dccbd6d.png";